module.exports = __webpack_public_path__ + "media/images/logo-header-962784cb5a670eb0ea0d27691718ee05.png";